import { Pagination as MuiPagination } from '@mui/material';

export default MuiPagination;
